export default [
  {
    path: '/main/reportdrivebehavior',
    meta: {
      tag: 'report_drivebehavior',
      name: 'Drive Behavior',
      breadcrumb: 'Drive Behavior'
    },
    component: () => import(/* webpackChunkName: "report-drivebehavior" */ '@/views/main/reports/drivebehavior/Index.vue'),
    children: [
      {
        path: '',
        name: 'listdrivebehavior',
        meta: {
          tag: 'report_drivebehavior',
          name: 'Drive Behavior',
          menu: 'reports',
        },
        component: () => import(/* webpackChunkName: "report-drivebehavior" */ '@/views/main/reports/drivebehavior/List.vue'),
      }
    ]
  }
]
